import { normalizeGitDiffPath } from './normalize-git-diff-path.js';

/** Git numstat path for renames: `common/{old=>new}`. Returns expanded paths. */
export function expandGitRenameNumstatPath(rawPath: string): { newPath: string; oldPath: string } | null {
  const open = rawPath.indexOf('{');
  const arrow = rawPath.indexOf('=>');
  const close = rawPath.lastIndexOf('}');
  if (open === -1 || arrow === -1 || close === -1 || open > arrow || arrow > close) {
    return null;
  }
  const prefix = rawPath.slice(0, open);
  const suffix = rawPath.slice(close + 1);
  const oldPart = rawPath.slice(open + 1, arrow).trim();
  const newPart = rawPath.slice(arrow + 2, close).trim();
  return {
    oldPath: normalizeGitDiffPath(`${prefix}${oldPart}${suffix}`),
    newPath: normalizeGitDiffPath(`${prefix}${newPart}${suffix}`),
  };
}

export function isGitRenameNumstatPath(rawPath: string): boolean {
  return expandGitRenameNumstatPath(rawPath) != null;
}
